import { differenceInYears } from 'date-fns';

export const isOverAge = (date: string | Date, ageLimit = 13) =>
  differenceInYears(new Date(), new Date(date)) >= ageLimit;
